import algoliasearch from 'algoliasearch/lite'
import getWithInMemoryCache from '../../utils/getWithInMemoryCache'
import {SEARCH_TOKEN_URL} from '../../libs/config'
import globals from '../../utils/globals'

export interface TagHit {
  id: number,
  name: string,
  count: number | string,
  selected?: boolean,
  _highlightResult?: {
    name: {
      value: string
    }
  }
}

export interface TagSearchResults {
  hitsPerPage: number,
  page: number,
  queryID: string,
  nbHits: number,
  hits: Array<TagHit>,
  nbPages: number,
  query: string
}

const DEFAULT_PAGE = 1
const DEFAULT_PAGE_SIZE = 25

export default class TagsIndex {
  private index?: algoliasearch.Index

  async setupIndex () {
    const data: {client_id: string, token: string} = await getWithInMemoryCache(SEARCH_TOKEN_URL, {})
    const client = algoliasearch(data.client_id, data.token)
    this.index = client.initIndex(`${globals('communityId')}-tags`)
  }

  async searchByName (name: string, page = DEFAULT_PAGE, pageSize = DEFAULT_PAGE_SIZE): Promise<TagSearchResults> {
    if (!this.index) {
      await this.setupIndex()
    }
    return this.index.search(name, {
      restrictSearchableAttributes: ['name'],
      page: page - 1,
      hitsPerPage: pageSize
    });
  }

  async getFirstRecordsFromNextPage(currentPage: number, pageSize: number = DEFAULT_PAGE_SIZE, length: number = 1) {
    if (!this.index) {
      await this.setupIndex()
    }
    return this.index.search('', {
      restrictSearchableAttributes: ['name'],
      offset: currentPage * pageSize,
      length: length
    });
  }

  clearCache() {
    if (!this.index) {
      return
    }

    this.index.clearCache()
  }
}
